







import { getImageUrl } from "@common/ImageUrlHelper";
import { Vue, Component, Prop } from "vue-property-decorator";
import { TicketStatus } from "@share/committees/common/types/TicketStatus";

@Component({})

export default class TicketStatusIcon extends Vue {

    @Prop({ required: true }) status: TicketStatus;

    getImageUrl(id: string) {
        return getImageUrl(this.backend, id);
    }

    get backend() {
        return this.$store.state.session.backend;
    }
}

